
/*global define */
define('jsx!components/livestocks/login-or-redirect-button',['react', 'lib'], function(React, lib) {
	var LoginOrRedirectButton = React.createClass({displayName: "LoginOrRedirectButton",
        renderLoginButton: function() {
            return (
                React.createElement("button", {className: "livestocks-button", onClick: window._coreHeaderLogin}, 
                    "Logg inn"
                )
            );
        },
        renderRedirectButton: function() {
            var path = lib.getBasePath() + '/aktiver-realtidskurser/aktiver';

            var matches = /source=([a-z0-9-_]+)/i.exec(window.location.search);
            if (matches && matches[1]) {
                path += '?source=' + matches[1];
            }

            return (
                React.createElement("a", {className: "livestocks-button", href: path}, 
                    "Aktiver sanntidskurser"
                )
            );
        },
		render: function() {
			if (lib.getUserId()) {
				return this.renderRedirectButton();
			} else {
				return this.renderLoginButton();
			}
		}
    });

    return function renderComponent(element, config) {
        if (!element) {
            return;
        }

        config = config || {};
        config.element = element;

        React.render(React.createElement(LoginOrRedirectButton, React.__spread({},  config)), element);
    };
});

